
<script>
export default {
  name: 'rex-checkbox-list',
  components: {},
  props: {
    name: {
      type: String,
      required: true
    },
    storeModule: {
      type: String,
      default: () => null,
      required: true
    },
    getterName: {
      type: String,
      default: () => null,
      required: true
    },
    setterName: {
      type: String,
      default: () => null,
      required: true
    },
    target: {
      type: String,
      default: () => null,
      required: true
    },
    labelsFormatter: {
      type: Function,
      default: () => null
    },
    data: {
      type: Array,
      default: () => []
    },
    labels: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    validate: {
      type: [String, Object],
      default: () => null
    },
  },
  data: () => ({
    listData: []
  }),
  inject: ['$validator'],
  computed: {
    value: {
      get() {
        return this.$store.getters[`${this.storeModule}/${this.getterName}`](this.target)
      },
      set(value) {
        this.$store.commit(`${this.storeModule}/${this.setterName}`, {
          target: this.target,
          value
        })

        if (this.error !== null) {
          const target = this.target.split('.')
          const err = this.$store.getters[`${this.storeModule}/${this.getterName}`](`${target[0]}Errors`)
          const currentFieldErrorIndex = err.map(x => x.field).indexOf(this.name)

          err.splice(currentFieldErrorIndex, 1)
          this.$store.commit(`${this.storeModule}/${this.setterName}`, err)
        }

        this.$emit('onChange', {
          event: value,
          element: this.$vnode.elm
        })
      }
    },
    error() {
      const target = this.target.split('.')
      const err = this.$store.getters[`${this.storeModule}/${this.getterName}`](`${target[0]}Errors`)
        .find(error => error.field === this.name)

      return err ? err.message : null
    },
    isSelectedAll() {
      return this.value.length === this.data.length
    },
    isNoSelected() {
      return this.value.length === 0
    }
  },
  created() {
    if (this.labels.length) {
      this.listData = this.data.map(item => ({
        ...item,
        ...this.labels.find(label => label.slug === item.slug)
      }))
    } else {
      this.listData = this.data
    }
  },
  methods: {
    selectAll() {
      if (!this.disabled) {
        this.value = this.data.map(item => item.slug)
      }
    },
    reset() {
      if (!this.disabled) {
        this.value = []
      }
    }
  }
}
</script>
<template>
  <div class="rex-checkbox-list">
    <div>
      <b-checkbox
        v-for="item in listData"
        :key="item.slug"
        v-model="value"
        v-validate="validate"
        :name="name"
        :disabled="disabled"
        :true-value="item.slug"
        :native-value="item.slug"
      >
        <div class="rex-checkbox-list__label">
          <div class="rex-checkbox-list__label-value">
            {{ item.name }}
          </div>
          <div
            v-if="labels.length"
            class="rex-checkbox-list__label-badge"
          >
            {{ labelsFormatter(item) }}
          </div>
        </div>
      </b-checkbox>
    </div>
    <div class="rex-checkbox-list__actions">
      <div>
        <a
          v-if="!isSelectedAll"
          href="javascript:;"
          @click="selectAll"
        >
          Выбрать все
        </a>
      </div>
      <div>
        <a
          v-if="!isNoSelected"
          href="javascript:;"
          @click="reset"
        >
          Сбросить
        </a>
      </div>
    </div>
  </div>
</template>
